import React from 'react';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { AccountService } from '@sm360/widget-commons-general';
import { InputCurrency, Card, CardSection } from '@sm360/ui-library';
import ActionButton from '../../../Components/ActionButton/ActionButton.jsx';

const AppraisalCard = ({ value, onSaveEstimate, onMakeAppointment, isActive, fetching = false }) => {
    const lang = LocaleService.getSimpleLocale();
    return (
        <section className={`appraisal-form--current-option clearfix ${isActive ? 'card-active' : ''}`}>
            <div className="appraisal-form--current-option--inner-container">
                <h4>{LocaleService.t('TRADE_IN.SECTIONS_CONTENT.VEHICLE_APPRAISAL.VALUE')}</h4>
                {Number.isInteger(value) ? (
                    <InputCurrency
                        value={value}
                        className="appraisal-form--current-option--inner-container--estimation"
                        locale={lang}
                        displayAsText
                    />
                ) : (
                    <div className="appraisal-form--current-option--inner-container--estimation">
                        <div>{lang === 'fr' ? 'XX XXX $' : '$ XX,XXX'}</div>
                        <Card color="alert" outline>
                            <CardSection>
                                <p className="uk-card--fail">
                                    {LocaleService.t('TRADE_IN.SECTIONS_CONTENT.VEHICLE_APPRAISAL.FAIL')}
                                </p>
                            </CardSection>
                        </Card>
                    </div>
                )}
                <p className="sr-text">{LocaleService.t('TRADE_IN.SECTIONS_CONTENT.VEHICLE_APPRAISAL.CONFIRMATION')}</p>
                {AccountService.isAuthenticated() && (
                    <p className="appraisal-form--current-option--inner-container--saved-estimation-txt">
                        {LocaleService.t('TRADE_IN.SECTIONS_CONTENT.VEHICLE_APPRAISAL.ESTIMATE_SAVED')}
                    </p>
                )}
                <div className="vehicle-buttons-container">
                    <div className="vehicle-buttons">
                        <ActionButton
                            next
                            noPrefix
                            noArrow
                            noSubmit
                            onClick={() => onSaveEstimate()}
                            checkedIcon={AccountService.isAuthenticated()}
                            disabled={AccountService.isAuthenticated()}
                            loading={fetching}
                        >
                            {LocaleService.t('TRADE_IN.BUTTONS.SAVE_ESTIMATE')}
                        </ActionButton>
                        <ActionButton
                            next
                            noPrefix
                            noArrow
                            noSubmit
                            onClick={() => onMakeAppointment()}
                            loading={fetching}
                        >
                            {LocaleService.t('TRADE_IN.BUTTONS.MAKE_APPOINTMENT')}
                        </ActionButton>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AppraisalCard;

AppraisalCard.displayName = 'AppraisalCard';
